<template>
    <div>

        <div>
            <a-form :form="form">
                <a-form-item>
                    <a-textarea
                        :rows="4"
                        placeholder="请输入评论内容（100字以内）"

                        diable="iscomment==0"
                        v-decorator="['comment_text',
                                      {
                                          rules: [

                                              {
                                                  required: true,
                                                  maxlength:100,
                                                  message: '请输入内容!',
                                              },
                                          ],
                                      },

                        ]" />
                </a-form-item>
                <a-form-item>
                    <a-button :aria-disabled="iscomment==0" @click="submit" :loading="submitting" type="primary">
                        发表评论
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-list
            v-if="commentList.length"
            :data-source="commentList"
            item-layout="horizontal">
            <a-list-item slot="renderItem" slot-scope="item">
                <div class="mycomment-box">
                    <div class="avatar-box">
                        <a-avatar
                            src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                    </div>
                    <div class="comment-con">
                        <div class="user">{{ item.comment_user }}</div>
                        <div class="comm-text" style="width:100%;"><p>
                            {{ item.comment_text }}
                        </p></div>
                    </div>
                    <div>{{ item.comment_date }}</div>
                </div>
            </a-list-item>
        </a-list>
        <div class="pagination-box">
            <!--<a-pagination-->
            <!--    v-model="current"-->
            <!--    :total="newRecomdExtra"-->
            <!--    @change="hotOnTableChanged">-->
            <!--</a-pagination>-->
            <a-pagination
                :total="commentExtra"
                :show-total="commentExtra => `共 ${commentExtra} 条`"
                @change="handleTableChange"
                :pagination="{current: commentQueries.pagination,pageSize: commentQueries.pageSize}" />
        </div>


    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';

    export default {
        filters: {
            newformatTime(data) {
                const hours = moment.duration(parseInt(data, 0)).hours();

                const seconds = moment.duration(parseInt(data, 0)).seconds();

                const minutes = moment.duration(parseInt(data, 0)).minutes();

                return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
            },
        },
        props: {
            iscomment: {
                type: Number,
                default: () => 1,
            },

        },
        data() {
            return {
                comments: [],
                submitting: false,
                value: '',
                form: this.$form.createForm(this),
            };
        },
        computed: {
            ...mapState('comment', [
                'commentList',
                'commentLoading',
                'commentExtra',
                'commentQueries',
            ]),

            ...mapState('videoDetailStore', [
                'videoDetail',
            ]),
            ...mapState(['userInfo']),
            ...mapState('params', ['liveParams']),
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        mounted() {
            const { mediaId } = this.$route.params;
            this.handleLoadList({ mediaId, mask: 0 });


            console.log(this.iscomment);
        },
        methods: {
            ...mapActions('comment', ['getCommentList', 'deleteComment', 'bulkDeleteComment', 'addComment']),
            handleLoadList(queries = {}) {
                if (!this.userInfo.user_name) {
                    return;
                }

                this.getCommentList(queries).catch(({ message }) => {
                    if (message) this.$message.error(message);
                });
            },
            handleChange(e) {
                this.value = e.target.value;
            },
            submit() {
                if (!this.userInfo.user_name) {
                    this.$message.error('请先登录');
                    return;
                }

                if (this.iscomment == 0) {
                    this.$message.error('此视频设置了不能评论');
                    return;
                }

                this.form.validateFields((err, values) => {
                    if (err) return;

                    if (!values.comment_text.replace(/\s+/g, '')) {
                        this.$message.error('评论不能为空');
                        return;
                    }
                    if ((values.comment_text.replace(/\s+/g, '')).length > 100) {
                        this.$message.error('评论不内容不能过长');
                        return;
                    }
                    const { mediaId } = this.$route.params;
                    const comment_user = this.userInfo.user_name;
                    const formData = {
                        comment_user,
                        media_id: mediaId,
                        ...values,
                    };

                    this.addComment(formData).then(() => {
                        this.$message.success('发表成功');
                        this.onReset();
                    }).catch(({ message }) => {
                        if (message) this.$message.error(message);
                    });
                });
            },
            onReset() {
                this.form.resetFields();
            },

            handleTableChange(paging) {
                const { mediaId } = this.$route.params;
                const queries = {
                    pagination: paging,
                    mediaId,
                };
                this.handleLoadList(queries);
            },
        },
    };
</script>
<style>
    .mycomment-box {
        display: flex;
        justify-content: space-around;
        width: 100%;
    }

    .avatar-box {
        width: 60px;
    }

    .comment-con {
        flex: 1;
        flex-direction: column;
        width: 100%;
    }

    .comment-con .user {
        font-size: 16px;
        color: #333;
    }

    .comm-text {
        width: 100%;
    }

    .pagination-box {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
    }
</style>
